<template>
  <div class="herocard" @click="flipCard">
    <img
      src="/assets/images/card/back.webp"
      alt="image host"
      class="herocard-back img-fluid"
      :class="{
        'herocard-back-animate': cardBackAnimate,
        'd-block': showBack,
        'd-none': !showBack,
      }"
    />
    <img
      :src="image"
      alt="image host"
      class="herocard-front img-fluid"
      :class="{
        'herocard-front-animate': cardFrontAnimate,
        'd-block': showFront,
        'd-none': !showFront,
      }"
    />
  </div>
</template>

<script>
export default {
  props: ['image'],
  data() {
    return {
      cardBackAnimate: false,
      cardFrontAnimate: false,
      showBack: true,
      showFront: false,
    };
  },
  mounted() {
    if (this.$device.mobile) {
      this.showBack = false;
      this.showFront = true;
    }
  },
  methods: {
    flipCard() {
      if (this.$device.mobile) return;

      this.cardBackAnimate = true;
      setTimeout(() => {
        this.showFront = true;
        this.showBack = false;
      }, 150);
      this.cardFrontAnimate = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes cardback {
  from {
    transform: rotateY(0);
  }
  to {
    transform: rotateY(90deg);
  }
}
@keyframes cardfront {
  from {
    transform: rotateY(90deg);
  }
  to {
    transform: rotateY(0);
  }
}
@keyframes hoverscale {
  from {
    transform: translate(0);
  }
  to {
    transform: translate(1.05);
  }
}

.herocard-box {
  text-align: center;
  .herocard {
    position: relative;
    height: 500px;
    width: 286px;
    @media (max-width: 767.98px) {
      height: 375px;
      width: 215px;
    }
    cursor: pointer;
    background-color: transparent;
    border: 0;
    transition: 0.3s ease-out;
    margin: 42px auto;
    &:hover {
      @media (min-width: 768px) {
        height: 524px;
        width: 300px;
        margin: 30px auto;
        -webkit-filter: drop-shadow(0px 0px 0.5rem #ffeca6);
        filter: drop-shadow(0px 0px 0.5rem #ffeca6);
      }
    }
    .herocard-back {
      display: block;
      height: 100%;
      width: auto;
    }
    .herocard-front {
      position: absolute;
      top: 0;
      left: 0;
      display: none;
      height: 100%;
      width: auto;
      transform: rotateY(0deg);
      z-index: 1;
    }
    .herocard-back-animate {
      animation: cardback 0.15s;
      transform: rotateY(90deg);
    }
    .herocard-front-animate {
      animation: cardfront 0.3s;
      transform: rotateY(0deg);
    }
    .sa-position {
      position: absolute;
      top: 30%;
      left: -50%;
      z-index: 0, 5;
    }
  }
  .herocard-turning {
    background-color: transparent;
    animation-name: none;
    &:hover {
      animation-name: none;
    }
  }
}
</style>
